import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getKeyNoteKey } from './use-get-key-note';
import { deleteKeyNotes } from './api/deleteKeyNoteFn';

import type { IKeyNoteData } from 'infrastructure/interfaces';
import type { ModuleType } from 'infrastructure/enums';

interface Props {
  module: ModuleType;
}

export const useDeleteKeyNote = ({ module }: Props) => {
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation({
    mutationFn: deleteKeyNotes,
    onSuccess(data, vars) {
      const queryKey = getKeyNoteKey({
        module,
        patientGuid: vars.patientGuid,
        showExpired: vars.showExpired,
      });
      queryClient.setQueryData<IKeyNoteData[]>(queryKey, (dataCache) => {
        if (!dataCache) return dataCache;

        if (data) {
          const newData = dataCache.filter(
            (item) => item.guid !== vars.noteGuid,
          );
          return newData;
        }
      });
    },
  });
  return { deleteKeyNote: mutate, isLoading };
};
